import { DEPLOYMENT_ID_COOKIE_NAME } from '@layers/web/constants/skew-protection.ts'

const reload = window.location.reload.bind(window.location)

export const useSkewProtection = () => {
  const { public: { VERCEL_DEPLOYMENT_ID } } = useRuntimeConfig()

  const checkForSkew = async (): Promise<boolean> => {
    try {
      const response = await fetch('/localapi/deployment-id', {
        cache: 'no-cache',
        credentials: 'omit',
      })

      // If we get a different deployment ID in response headers, we have skew
      const responseDeploymentId = (await response.json()).deploymentId

      return (
        responseDeploymentId &&
        VERCEL_DEPLOYMENT_ID &&
        responseDeploymentId !== VERCEL_DEPLOYMENT_ID
      )
    } catch {
      // If we can't check, assume no skew
      return false
    }
  }

  const clearDeploymentIdCookie = () => {
    document.cookie = `${DEPLOYMENT_ID_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
  }

  const reloadToLatestDeployment = () => {
    clearDeploymentIdCookie()
    window.caches.keys()
      .then(keys => keys.forEach(key => caches.delete(key)))
    reload()
  }

  return {
    clearDeploymentIdCookie,
    checkForSkew,
    reloadToLatestDeployment,
  }
}